/** Shrink + JPEG-encode vision inputs so Bedrock converse stays under API GW / Lambda limits. */
function loadImage(src) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error("Caricamento immagine vision fallito"));
        img.src = src;
    });
}
const DEFAULT_MAX_SIDE = 1280;
const DEFAULT_JPEG_QUALITY = 0.82;
/**
 * Browser-only: downscale and JPEG-compress a data URL before Bedrock vision.
 * Headless (vitest) returns input unchanged.
 */
export async function compressDataUrlForVision(dataUrl, opts) {
    if (typeof document === "undefined" || !dataUrl.startsWith("data:image/")) {
        return dataUrl;
    }
    const maxSide = opts?.maxSide ?? DEFAULT_MAX_SIDE;
    const quality = opts?.jpegQuality ?? DEFAULT_JPEG_QUALITY;
    const img = await loadImage(dataUrl);
    let w = img.naturalWidth || img.width;
    let h = img.naturalHeight || img.height;
    if (!w || !h)
        return dataUrl;
    const scale = Math.min(1, maxSide / Math.max(w, h));
    w = Math.max(1, Math.round(w * scale));
    h = Math.max(1, Math.round(h * scale));
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx)
        return dataUrl;
    ctx.drawImage(img, 0, 0, w, h);
    return canvas.toDataURL("image/jpeg", quality);
}
